import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const TABS = [
  { to: '/creators', label: '타깃 풀' },
  { to: '/creators/outreaches', label: 'DM 보내기' },
]

/** The two halves of 인플루언서: who to reach, and what to send them. Two
 *  short tabs fit any width, so the bar does not scroll: overflow-x-auto made
 *  the y axis scroll too, and the active underline's 1px below the border
 *  showed a scrollbar. */
export function CreatorsTabs() {
  return (
    <nav aria-label="인플루언서 화면" className="flex border-b border-border">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end
          className={({ isActive }) =>
            cn(
              'relative shrink-0 whitespace-nowrap px-3 py-2 text-body font-medium transition-colors',
              isActive
                ? 'text-foreground after:absolute after:inset-x-3 after:-bottom-px after:h-0.5 after:bg-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
